import Chart1 from "../../../../src/assets/chart1";
import Chart2 from "../../../../src/assets/chart2";
import React from 'react';
export default {
  Chart1,
  Chart2,
  React
};